import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { dataStore } from 'src/app/app.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatError, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

export interface DialogData {
  type: string;
  user: any;
}

@Component({
  selector: 'app-change-credits',
  templateUrl: './change-credits.component.html',
  styleUrls: ['./change-credits.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatHint,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class ChangeCreditsComponent implements OnInit {
  creditForm: UntypedFormGroup;
  pinEnabled: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ChangeCreditsComponent>,
  ) {}

  ngOnInit() {
    this.creditForm = this.fb.group({
      credits: [0, [Validators.required, Validators.min(0.5)]],
      pin: [],
      remarks: [],
    });
    this.pinEnabled = dataStore.generalSettings.askPin;
    if (this.pinEnabled) {
      this.creditForm
        .get('pin')
        .setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4)]);
    }
  }

  save() {
    if (this.creditForm.valid) {
      this.dialogRef.close(this.creditForm.value);
    }
  }
}
